import clsx from 'clsx'
import React, { memo, useRef } from 'react'

import GridContainer from '@deltek/specification-client/core/Surfaces/GridContainer'
import Grid from '@material-ui/core/Grid'
import { useElementItemShallowSelector } from 'components/WorkspaceEditor/ElementItemStore'
import { useSuggestionsShallowSelector } from 'components/WorkspaceEditor/SuggestionStore'
import { useShallowSelector } from 'components/WorkspaceEditor/Workspace2Store'
import {
    TrackChangesActionsPopover,
    TrackChangesFilter,
    TrackChangeSideBar,
    TrackChangesPanelActions,
} from './components'
import { useDebouncedFetch } from './hooks'
import { useTrackChangesPanelEffect } from './hooks/useTrackChangesPanelEffect'
import { useTrackChangesUpdateService } from './services'
import { useTrackedChangesPanelStyles } from './styles'

export const TrackChangesPanel = memo(
    ({ isSidebarVisible }: { isSidebarVisible: boolean }) => {
        const {
            trackChangesPanelBeta,
            sidebar,
            sidebarOpen,
            sidebarClosed,
        } = useTrackedChangesPanelStyles()
        const [
            isActionPopoverDisplayed,
            setIsActionPopoverDisplayed,
        ] = React.useState(false)
        const actionRef = useRef<HTMLButtonElement | null>(null)
        const {
            isSuggestionsDataUpdated,
            setIsLoadingCards,
        } = useSuggestionsShallowSelector((state) => ({
            isSuggestionsDataUpdated: state.isSuggestionsDataUpdated,
            setIsLoadingCards: state.setIsLoadingCards,
        }))
        const { debouncedFetchAndProcess } = useDebouncedFetch()
        const { isTreeLoading } = useShallowSelector((s) => ({
            isTreeLoading: s.isTreeLoading,
        }))

        const elementId = useElementItemShallowSelector(
            (s) => s.elementItemValue.elementId
        )
        const handleActionPopoverClick = React.useCallback(() => {
            setIsActionPopoverDisplayed((open) => !open)
        }, [])

        useTrackChangesPanelEffect({
            isSuggestionsDataUpdated: Boolean(isSuggestionsDataUpdated),
            isTreeLoading,
            elementId,
            setIsLoadingCards,
            debouncedFetchAndProcess,
            isSidebarVisible,
        })
        useTrackChangesUpdateService()

        return (
            <Grid
                id="rightPanelBeta"
                className={clsx(
                    sidebar,
                    isSidebarVisible ? sidebarOpen : sidebarClosed
                )}
            >
                <GridContainer
                    data-testid="trackChangesPanelBeta"
                    id="rightPaneInnerContainerId"
                    className={clsx(trackChangesPanelBeta)}
                >
                    <TrackChangesPanelActions
                        actionRef={actionRef}
                        handleActionPopoverClick={handleActionPopoverClick}
                        isActionPopoverDisplayed={isActionPopoverDisplayed}
                    />
                    <TrackChangesFilter />
                    <TrackChangeSideBar />
                    <TrackChangesActionsPopover
                        actionRef={actionRef}
                        handleActionPopoverClick={handleActionPopoverClick}
                        isActionPopoverDisplayed={isActionPopoverDisplayed}
                    />
                </GridContainer>
            </Grid>
        )
    }
)
